import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLogOut } from 'react-icons/fi';
import logo from "../assets/right.png";
import { useLocation } from 'react-router-dom';


const LogoutAlertPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const message = location.state?.message || 'Process Completed';
  const [showGoodbye, setShowGoodbye] = useState(false);

  useEffect(() => {
    const tataTimer = setTimeout(() => {
      setShowGoodbye(true);
    }, 1000); 

    const timer = setTimeout(() => {
      navigate('/');
    }, 1500);

    return () => {
      clearTimeout(timer);
      clearTimeout(tataTimer);
    };
  }, [navigate]);

  return (
    <div className="logout-alert-container">
      <div className={`logout-alert-content ${showGoodbye ? 'goodbye-animation' : ''}`}>
        <img src={logo} alt="Logo" class="logo" />
        {/* <FiLogOut className="logout-icon" /> */}
        <h2>{message}</h2>
        {/* {showGoodbye && <div className="goodbye">👋 Thank You</div>}  */}
        {showGoodbye} 
      </div>
    </div>
  );
};

export default LogoutAlertPage;
